import { handleActions } from "redux-actions";
import saveAs from "file-saver";
import Swal from "sweetalert2";
import moment from "moment";
import XLSX from "xlsx";
import _ from "lodash";
import { change, reset } from "redux-form";
import { pendingTransferColumns } from "../../common/utility/constants";
import app from "../../libs/apiClient";
import { push } from "react-router-redux";
import { errorHandler } from '../../common/utility/constants';
import { reservationsCharterBookings } from "../../routesConfiguration/paths";
import { actions as breadcrumbActions } from "./breadcrumb";

// Constants
const service = app.service("/api/reservation/");
const reportService = app.service("/api/reservations-report");

const PAGE = "LEGACY_RESERVATIONS_PAGE";
const DATA = "LEGACY_RESERVATIONS_DATA";
const LOADER = "LEGACY_RESERVATIONS_LOADER";
const QUERY = "LEGACY_RESERVATIONS_QUERY";
const RESERVATION = "LEGACY_RESERVATIONS_RESERVATION";
const MODAL_RESERVATIONS = "LEGACY_MODAL_RESERVATIONS";

// Pure Actions
const setData = (data) => ({
    type: DATA,
    data,
});

const setPage = (page) => ({
    type: PAGE,
    page,
});

export const setQuery = (query) => ({
    type: QUERY,
    query,
});

const setLoader = (loading) => ({
    type: LOADER,
    loading,
});

const setReservation = (reservation) => ({
    type: RESERVATION,
    reservation,
});

// Actions
export const find = (page, size = 10) => (dispatch, getState) => {
    dispatch(setLoader(true));
    const { values = {} } = getState().form.legacyReservationListFilter || {};
    const { query: stateQuery, page: statePage } = getState().reservations;
    page = page || statePage;

    const query = {
        query: {
            $skip: (page - 1) * size,
            $limit: size,
            ...stateQuery,
            $sort: { _id: -1 },
            cart: null,
            canceled: { $ne: true },
        },
    };

    if (values) {
        if(values.filter){
            if(values.filter === 'upcoming'){
                query.query.puTime = { $gte: moment().endOf('day') };
                query.query.$sort = { _id: 1 }
            } else if(values.filter === 'booking'){
                query.query.$sort = { _id: -1 }
            } else if(values.filter === 'passenger'){
                query.query.$sort = { guestLastNm: 1 }
            }
        }

        if (values.type) {
            query.query.$or = [
                { vehicleType: { $regex: _.escapeRegExp(values.type) } },
                { guestFirstNm: { $regex: _.escapeRegExp(values.type) } },
                { guestLastNm: { $regex: _.escapeRegExp(values.type) } },
                { puAddress: { $regex: _.escapeRegExp(values.type) } },
                { doAddress: { $regex: _.escapeRegExp(values.type) } },
            ];
            if(!isNaN(parseInt(values.type))){
                query.query.$or.push({ confirmationNo: parseInt(values.type) });
                query.query.$or.push({ liveryNo: parseInt(values.type) })
            }
        }

        if (values.startDate && values.endDate) {
            if (
                moment(values.startDate).isSameOrBefore(moment(values.endDate))
            ) {
                const eD = moment(values.endDate).hours("23").minutes("59").seconds("59");
                query.query.puTime = { $lte: eD, $gte: values.startDate };
            }
        }

        if (values.limitDate) {
            query.query.puTime = {
                $gt: moment(values.limitDate).hours("23").minutes("59").seconds("59"),
                $lt: moment().startOf('day'),
            };
        }

        if (values.unassigned) {
            query.query.driverAssigned = !values.unassigned;
        }

        if (values.canceled){
            query.query.canceled = values.canceled;
        }

        if (values.guestName) {
            const [fName, lName = fName] = values.guestName.split(" ");

            query.query.$or = [
                { guestFirstNm: { $regex: _.escapeRegExp(fName) } },
                { guestLastNm: { $regex: _.escapeRegExp(lName) } },
            ];
        }
    }

    service.find(query)
        .then((response) => {
            dispatch(setData(response));
            dispatch(setPage(page));
        })
        .catch((err) => {
            dispatch(errorHandler(err));
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

export const destroy = (id) => async (dispatch, getState) => {
    dispatch(setLoader(true));
    try {
        Swal({
            title: "Are you sure?",
            text: "You cannot undo this action!",
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel",
            confirmButtonColor: "#D50032",
            cancelButtonColor: "#545b62",
            reverseButtons: true,
        }).then(async (result) => {
            if (result.value) {
                await service.remove(id);
                dispatch(push(reservationsCharterBookings));
            }
        });
    } catch (e) {
        dispatch(errorHandler(e));
    } finally {
        dispatch(setLoader(false));
    }
};

const download = (rows) => (dispatch) => {
    if (rows) {
        dispatch(setLoader(true));
        reportService
            .find()
            .then((data) => {
                const headers = rows.split(",");
                const collection = [
                    headers.map((value) => {
                        return _.find(pendingTransferColumns, { value }).label;
                    }),
                ];
                data.data.forEach((item) => {
                    collection.push(
                        headers.map((header) => {
                            return item[header] ? item[header] : "";
                        })
                    );
                });
                const wb = XLSX.utils.book_new();
                wb.Props = {
                    Title: "Transfer Reservations",
                    Subject: "Reservations",
                    Author: "BBC EXPRESS",
                    CreatedDate: new Date(),
                };
                const ws = XLSX.utils.aoa_to_sheet(collection);
                XLSX.utils.book_append_sheet(wb, ws, "Transfer Reservations");
                const wbout = XLSX.write(wb, {
                    bookType: "xlsx",
                    type: "binary",
                });
                function s2ab(s) {
                    const buf = new ArrayBuffer(s.length); // convert s to arrayBuffer
                    const view = new Uint8Array(buf); // create uint8array as viewer
                    for (let i = 0; i < s.length; i++)
                        view[i] = s.charCodeAt(i) & 0xff; // convert to octet
                    return buf;
                }
                saveAs(
                    new Blob([s2ab(wbout)], {
                        type: "application/octet-stream",
                    }),
                    "Pending Reservations.xlsx"
                );
            })
            .catch((err) => {
                dispatch(errorHandler(err));
            })
            .finally(() => {
                dispatch(setLoader(false));
            });
    }
};

const resendEmail = (id) => (dispatch) => {
    Swal.fire({
        title: "Resend confirmation email?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Send",
        cancelButtonText: "No, cancel",
        confirmButtonColor: "#D50032",
        cancelButtonColor: "#545b62",
        reverseButtons: true,
    }).then((response) => {
        if (response.dismiss) return;

        dispatch(setLoader(true));

        service.update(id, {
                action: "RESEND_EMAIL_RECEIPT",
                payload: { sendTo: 'passenger' },
            })
            .then(() => {
                Swal.fire({
                    title: "Email sent",
                    type: "success",
                    confirmButtonColor: "#D50032",
                });
            })
            .catch((err) => {
                dispatch(errorHandler(err));
            })
            .finally(() => {
                dispatch(setLoader(false));
            });
    });
};

const getReservation = (id) => (dispatch) => {
    dispatch(setLoader(true));
    service
        .get(id, { query: { $populate: ['quoteId'] }})
        .then((data) => {
            dispatch(setReservation(data));
            const { updateCustomLabel } = breadcrumbActions;
            dispatch(updateCustomLabel(id, data.confirmationNo));
        })
        .catch((err) => {
            dispatch(errorHandler(err));
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

const setAssigned = (liveryNo) => async (dispatch, getState) => {
    dispatch(setLoader(true));
    const { _id } = getState().reservations.reservation;

    try {
        const res = await service.patch(_id, {
            driverAssigned: true,
            liveryNo,
        });
        return res;
    } catch (err) {
        dispatch(errorHandler(err));
    } finally {
        dispatch(setLoader(false));
    }
};

export const openModalReservation = (modalReservations) => (dispatch) => {
    dispatch({
        type: MODAL_RESERVATIONS,
        modalReservations
    });
}

const clearDates = () => (dispatch, getStore) =>{
    dispatch(change('legacyReservationListFilter','startDate', ""));
    dispatch(change('legacyReservationListFilter','endDate', ""));
    dispatch(find(1));
}

const clear = () => (dispatch, getStore) => {
    dispatch(setReservation({}));
}

export const actions = {
    find,
    clear,
    destroy,
    download,
    clearDates,
    setAssigned,
    resendEmail,
    getReservation,
    openModalReservation,
};

// Reducers
const reducers = {
    [LOADER]: (state, { loading }) => ({ ...state, loading }),
    [PAGE]: (state, { page }) => ({ ...state, page }),
    [QUERY]: (state, { query }) => ({ ...state, query }),
    [DATA]: (state, { data }) => ({ ...state, data }),
    [RESERVATION]: (state, { reservation }) => ({ ...state, reservation }),
    [MODAL_RESERVATIONS]: ( state, { modalReservations }) => ({ ...state, modalReservations }),
};

export const initialState = {
    data: {
        total: 0,
        limit: 10,
        skip: 0,
        data: [],
    },
    page: 1,
    query: {},
    loading: false,
    reservation: {},
    modalReservations: false,
};

export default handleActions(reducers, initialState);
